module.exports = __webpack_public_path__ + "img/ic_16_arrow_white.8277111c.svg";